import useIsMobile from '@hooks/use-is-mobile';
import { cn, shouldUseMaxHight } from '@lib/utils';
import DesktopPDFViewer from './desktop-pdf-viewer';
import MobilePDFViewer from './mobile-pdf-viewer';

function PDFViewer() {
  const isMobile = useIsMobile();

  return (
    // [hexal]
    <div
      className={cn(shouldUseMaxHight() && 'max-h-[900px] sm:max-h-[700px] overflow-y-scroll')}
      data-iframe-size=""
    >
      {isMobile ? <MobilePDFViewer /> : <DesktopPDFViewer />}
    </div>
  );
}

export default PDFViewer;
